import React from 'react';
import type { Link } from '@noths/polaris-dev-ts-types';

import { LinkCarousel, LinkCarouselTrackingCategory } from 'src/components/organisms/LinkCarousel';
import * as styles from '../styles';

interface AccordionContentProps {
  categoryDescription: string;
  categoryLinks: Link[];
  categorySubheading?: string;
  enableCopyBlockContent: boolean;
}

export const AccordionContent = ({
  categoryDescription,
  categoryLinks,
  categorySubheading,
  enableCopyBlockContent = true,
}: AccordionContentProps) => (
  <>
    {categorySubheading && <h2 css={styles.subHeading}>{categorySubheading}</h2>}
    {enableCopyBlockContent && (
      <div css={styles.copyBlockContentCSS}>
        <div dangerouslySetInnerHTML={{ __html: categoryDescription }} />
      </div>
    )}
    {categoryLinks.length > 0 && (
      <section css={styles.linksCarouselSection}>
        <div css={[styles.insetSectionContent, styles.linksCarouselWrapper]}>
          <LinkCarousel
            id="categories"
            title="Categories"
            trackingCategory={LinkCarouselTrackingCategory.ChildCategory}
            links={categoryLinks}
          />
        </div>
      </section>
    )}
  </>
);
